// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_WpZ5l","pagination":"List_pagination_1afcx","paginationText":"List_paginationText_3DDjl","paginationButton":"List_paginationButton_3uH5S"};